var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.032 5.467L11.11.352A1.178 1.178 0 0111.956 0c.2 0 .388.048.552.139a.986.986 0 01.2.133.58.58 0 01.09.08l5.078 5.115c.466.47.466 1.235 0 1.705-.47.47-1.226.47-1.692 0l-3.033-3.06v12.691c0 .666-.538 1.205-1.195 1.205a1.2 1.2 0 01-1.196-1.205V4.111l-3.036 3.06c-.466.47-1.223.47-1.692 0a1.214 1.214 0 010-1.704zM22.482 26H1.426A1.2 1.2 0 01.23 24.795v-6.892a1.2 1.2 0 011.196-1.205 1.2 1.2 0 011.195 1.205v5.687h18.666v-5.687a1.2 1.2 0 011.195-1.205 1.2 1.2 0 011.195 1.205v6.892A1.2 1.2 0 0122.482 26z",
    fill: "#262E37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/Ic_upload.f201ccc105ffdb5d5f5d0cc3f59d73d0.svg";
export { ForwardRef as ReactComponent };